"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["isDisabled", "isChevron", "onClick", "children", "customClass"];

var Pager = function Pager(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$isChevron = _ref.isChevron,
      isChevron = _ref$isChevron === void 0 ? false : _ref$isChevron,
      onClick = _ref.onClick,
      children = _ref.children,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var options = {
    class: (0, _classnames.default)('control-pagination--pager-item', isDisabled ? 'disabled' : null, isChevron ? 'chevron' : null, customClass),
    onClick: !isDisabled ? onClick : undefined
  };
  return (0, _preact.h)("div", (0, _extends2.default)({}, restProps, options), children);
};

var _default = Pager;
exports.default = _default;